module.exports = __webpack_public_path__ + "static/media/advisor-introduction-ilkka-suhonen.3d4cb84e.jpg";